import { Layout, Menu } from "antd";
import {
  AppstoreOutlined,
  FormOutlined,
  ShopOutlined,
  TagOutlined,
  CarOutlined,
  PercentageOutlined,
  DollarOutlined,
  UserSwitchOutlined
} from "@ant-design/icons";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = ({ setActivePage }) => {
  return (
    <Sider width={250} theme="light">
      <Menu
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        onClick={(e) => setActivePage(e.key)}
      >
        <Menu.Item key="dashboard" icon={<AppstoreOutlined />}>
          Dashboard
        </Menu.Item>
        <Menu.Item key="users" icon={ <UserSwitchOutlined />}>
          Quản lý tài khoản
        </Menu.Item>
        <Menu.Item key="news" icon={<FormOutlined />}>
          Quản lý bài viết
        </Menu.Item>
        <Menu.Item key="voucher" icon={<PercentageOutlined />}>
          Quản lý voucher
        </Menu.Item>

        <Menu.Item key="transaction" icon={<PercentageOutlined />}>
          Quản lý phiên giao dịch
        </Menu.Item>

        <Menu.Item key="order" icon={<DollarOutlined />}>
          Quản lý đơn hàng
        </Menu.Item>

        {/* Menu cha - Quản lý sản phẩm */}
        <SubMenu key="products" icon={<ShopOutlined />} title="Quản lý sản phẩm">
          <Menu.Item key="list-product" icon={<ShopOutlined />}>
            Danh sách sản phẩm
          </Menu.Item>
          <Menu.Item key="product-types" icon={<TagOutlined />}>
            Phân loại sản phẩm
          </Menu.Item>
          <Menu.Item key="shipping" icon={<CarOutlined />}>
            Quản lý vận chuyển
          </Menu.Item>
        </SubMenu>

             <Menu.Item key="order" icon={<DollarOutlined />}>
          Quản lý đơn hàng
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
